<template>
  <div class="bg">
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="orderNo" :placeholder="$t('message.mainOrDeputyPlaceholder')"></el-input>
        </div>
        <div class="search_item">
          <el-select v-model="orderStatus" :placeholder="$t('message.amazonOrderStatus')" clearable>
            <el-option :label="$t('message.signInOrderStatus2')" value="1"></el-option>
            <el-option :label="$t('message.signInOrderStatus1')" value="2"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-input v-model="orderAddress" :placeholder="$t('message.addressInOrder')"></el-input>
        </div>
        <div class="search_item" v-if="!containerId && $store.state.JHSS.personalUserid.includes('admin')">
          <el-select v-model="searchCustomer" filterable style="margin-left: 20px;" :placeholder="$t('message.exportDatePlaceholder') + $t('message.customTableTitle2')">
            <el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-input v-model="orderRemark" :placeholder="$t('message.containerOrderRemark')"></el-input>
        </div>
        <div class="search_item">
          <el-select v-model="logisticsStatus" :placeholder="$t('message.containerOrderLogisticsStatus')" clearable>
            <el-option :label="$t('message.deliverySituation1')" value="已提货"></el-option>
            <el-option :label="$t('message.deliverySituation2')" value="配送中"></el-option>
            <el-option :label="$t('message.deliverySituation3')" value="已派送"></el-option>
            <el-option :label="$t('message.deliverySituation4')" value="提回仓库"></el-option>
            <el-option :label="$t('message.deliverySituation5')" value="拒收"></el-option>
            <el-option :label="$t('message.deliverySituation6')" value="再次派送"></el-option>
              <el-option :label="$t('message.deliverySituation7')" value="未操作"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" type="datetimerange" range-separator=" - " :start-placeholder="$t('message.signInTimeStartPlaceholder')" :end-placeholder="$t('message.signInTimeEndPlaceholder')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="search_btn" @click="querySignInOrder">{{$t('message.queryBtnText')}}</div>
        <div v-if="containerId" class="add_btn" style="margin-right: 28px;" @click="downloadTemplate"><img class="add_icon" src="@/assets/downloadIocn.svg" />{{$t('message.downLoadExcel')}}</div>
        <div v-if="containerId" class="search_btn" @click="uploadTemplate">{{$t('message.uploadBtnText')}}</div>
      </div>
    </div>
    <div class="content">
			
      <signInCalendar v-if="showCalendar"></signInCalendar>
      <orderList v-else ref="amazonOrderList" :container-id="containerId" :order-no="orderNo" :order-time="orderTime" :order-status="orderStatus" :order-address="orderAddress" :search-customer="searchCustomer" :order-remark="orderRemark" :logistics-status="logisticsStatus"></orderList>
    </div>
    <!-- 下载模板 -->
    <el-dialog :title="$t('message.orderTemplateDialogTitle')" :visible.sync="showDownLoad" width="25%" destroy-on-close :close-on-click-modal="false">
      <div>
        <div class="dialog_row">
          <div class="dialog_item" style="justify-content: center;">
            <el-link class="dialog_item_title" type="primary" :underline="false" :href="templateDownloadUrl1">{{$t('message.specialTemplate')}}</el-link>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item" style="justify-content: center;">
            <el-link class="dialog_item_title" type="primary" :underline="false" :href="templateDownloadUrl2">{{$t('message.normalTemplate')}}</el-link>
          </div>
        </div>
        <div class="dialog_row" v-if="specialIdentity === 'FC' || specialIdentity === 'administrator'">
          <div class="dialog_item" style="justify-content: center;">
            <el-link class="dialog_item_title" type="primary" :underline="false" :href="templateDownloadUrl3">{{$t('message.FCSpecialTemplate')}}</el-link>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 下载模板 -->
    <!-- 上传订单 -->
    <el-dialog :title="$t('message.orderTemplateUploadTitle')" :visible.sync="showUpload" width="40%" destroy-on-close :close-on-click-modal="false">
      <div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.signInOrderCustomer')}}：</span>
            <el-select v-model="customerSel" filterable style="margin-left: 20px;" :placeholder="$t('message.exportDatePlaceholder')">
              <el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.templateTypeTitle')}}：</span>
            <el-radio-group v-model="templateType" style="margin-left: 20px;">
              <el-radio label="特别模板">{{$t('message.specialTemplate')}}</el-radio>
              <el-radio label="通用模板">{{$t('message.normalTemplate')}}</el-radio>
              <el-radio label="FC-特别模板" v-if="specialIdentity === 'FC' || specialIdentity === 'administrator'">{{$t('message.FCSpecialTemplate')}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.uploadFileTitle')}}：</span>
            <el-upload :action="uploadUrl" :limit="1" :on-change="uploadChange" :on-success="handleSuccess" :on-remove="handleRemove" style="margin-left: 20px;display: flex;align-items: baseline;">
              <el-button class="add_btn" icon="el-icon-upload">{{$t('message.importExcelTitle')}}</el-button>
            </el-upload>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showUpload = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="uploadOrderFile" :disabled="!this.importFile">{{$t('message.orderTemplateUploadTitle')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 上传订单 -->
  </div>
</template>

<script>
  import { getCustomer, imgSrc, uploadImg, setAmazonOrder } from '@/api/getData.js'
  import XLSX from 'xlsx'
  import signInCalendar from './signInCalendar.vue'
  import orderList from './orderList.vue'
  export default {
    name: 'amazonOrder',
    components: { signInCalendar, orderList },
    data () {
      return {
        orderNo: '', // 主单号/副单号
        orderTime: null, // 订单创建时间
        orderStatus: '', // 订单状态
        orderAddress: '', // 订单地址
        searchCustomer: '', // 搜索栏客户名称
        orderRemark: '', // 备注
        logisticsStatus: '', // 物流状态
        showCalendar: false, // 签收单日历 / 订单
        showDownLoad: false, // 下载模板
        showUpload: false, //上传弹窗
        customerLsit: [], // 客户列表
        customerSel: '', // 客户选择列表
        templateType: '通用模板',
        importOrder: [],
        importFile: '',
        importFileOldName: ''
      }
    },
    created() {
      // let userid = this.$store.state.JHSS.personalUserid
      this.specialIdentity = this.$store.state.JHSS.personalUserid !== 'administrator' ? this.$store.state.JHSS.personalSpecial : 'administrator'
      if (!this.$route.query.customerID) {
        this.getCuetomer()
      } else {
        this.customerLsit = [{
          label: this.$route.query.customerID.split(',')[0],
          value: this.$route.query.customerID.split(',')[1]
        }]
        this.customerSel = this.$route.query.customerID.split(',')[1]
      }
      // if (userid.includes('admin')) {
      //   this.getCuetomer()
      // } else {
      //   this.customerLsit = [{
      //     label: this.$store.state.JHSS.personalAccount,
      //     value: this.$store.state.JHSS.personalUserid
      //   }]
      // }
    },
    methods: {
      // 查询客户列表
      async getCuetomer () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { IFQUERY: '1' }
        let res = await getCustomer(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data.dt)
          this.customerLsit = res.data.dt.map(item => {
            return {
              label: item.USHOWNAME + '——' + item.GUDING1,
              value: item.USERID
            }
          })
        }
      },
      // 查询订单
      querySignInOrder () {
        this.showCalendar = false
        setTimeout(() => {
          this.$refs.amazonOrderList.queryOrder()
        }, 100)
      },
      // 下载模板
      downloadTemplate () {
        this.showDownLoad = true
      },
      // 上传文件
      uploadTemplate () {
        // this.customerSel = ''
        this.importOrder = []
        this.showUpload = true
      },
      handleRemove (file) {
        // console.log(file)
        this.importOrder = []
        this.importFile = ''
        this.importFileOldName = ''
      },
      // 上传成功
      handleSuccess (file) {
        console.log('success', file)
        this.importFile = file.data.filename
        this.importFileOldName = file.data.fileoldname
      },
      // 导入excle
      uploadChange (file) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let _this = this
        let nameList = file.name.split('.')
        const types = nameList[nameList.length - 1]
        const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
        if (!fileType) {
          loading.close()
          this.$message(this.$t('message.uploadOrderFileError'))
        } else {
          this.file2Xce(file).then(tabJson => {
            loading.close()
            if (tabJson && tabJson.length > 0) {
              // this.xlsxJson = tabJson
              // console.log('导入数据：', tabJson[0].sheet)
              this.importOrder = tabJson[0].sheet.map(item => {
                let obj = {
                  CUSTOMERID: this.customerSel,
                  ADDUSER: this.$store.state.JHSS.personalUserid,
                  JZXID: this.containerId,
                  GUDING1: this.importFile,
                  GUDING2: this.importFileOldName
                }
                if (this.templateType === '通用模板') {
                  obj.MBLNO = item['MARK']?item['MARK']:item['MBL NO']
                  obj.HBLNO = item['貨物番号']?item['貨物番号']:item['HBL NO']

                  obj.SL = item['個数']
                  obj.ZL = item['重量']
                  obj.DELIVERYADD = item['DELIVERY ADD']
                  obj.JHR = item['集荷日']
                  obj.GUDING3 = item['CUSTOMER ID']
                  obj.GUDING4 = item['CBM']
                  obj.GUDING5 = item['備考']
                } else if (this.templateType === '特别模板') {
                  obj.MBLNO = item['MAWB番号']
                  obj.HBLNO = item['送り状番号']
                  obj.SL = item['個数']
                  obj.ZL = item['重量']
                  obj.DELIVERYADD = item['荷受人名称']
                  obj.JHR = item['転送日時']
                  obj.GUDING3 = item['客户ID']
                } else if (this.templateType === 'FC-特别模板') {
                  obj.HBLNO = item['配車番号']
                  obj.SL = item['個数']
                  obj.ZL = item['重量']
                  obj.GUDING4 = item['容積']
                  let a = !item['郵便番号'] ? '' : item['郵便番号']
                  let b = !item['住所１'] ? '' : item['住所１']
                  let c = !item['住所２'] ? '' : item['住所２']
                  let d = !item['納品先'] ? '' : item['納品先']
                  let e = !item['担当者'] ? '' : item['担当者']
                  let f = !item['電話番号'] ? '' : item['電話番号']
                  obj.DELIVERYADD = a + '<br/>' + b + c + '<br/>' + d + '<br/>' + e + '<br/>' + f
                }
                return obj
              })
            } else {
              this.$message(this.$t('message.uploadOrderNoFileError'))
            }
          })
        }
      },
      // 解析excel
      file2Xce (file) {
        return new Promise(function(resolve, reject) {
          const reader = new FileReader()
          reader.onload = function(e) {
            const data = e.target.result
            this.wb = XLSX.read(data, {
              type: 'binary'
            })
            const result = []
            this.wb.SheetNames.forEach((sheetName) => {
              result.push({
                sheetName: sheetName,
                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
              })
            })
            resolve(result)
          }
          reader.readAsBinaryString(file.raw)
          // reader.readAsBinaryString(file) // 传统input方法
        })
      },
      // 确定上传文件
      async uploadOrderFile () {
        // console.log(this.importOrder)
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = this.importOrder.map(item => {
          item.CUSTOMERID = this.customerSel
          item.ADDUSER = this.$store.state.JHSS.personalUserid
          item.GUDING1 = this.importFile
          item.GUDING2 = this.importFileOldName
          return item
        })
        let res = await setAmazonOrder(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.showUpload = false
          this.orderNo = ''
          this.orderTime = null
          this.orderStatus = ''
          this.orderAddress = ''
          this.searchCustomer = ''
          // this.customerSel = ''
          this.orderRemark = ''
          this.logisticsStatus = ''
          this.importOrder = []
          this.showCalendar = false
          setTimeout(() => {
            this.$refs.amazonOrderList.getAmazonOrder()
          }, 100)
        }
      }
    },
    computed: {
      templateDownloadUrl1 () {
        return imgSrc('amz02.xlsx')
      },
      templateDownloadUrl2 () {
        return imgSrc('amz01.xlsx')
      },
      templateDownloadUrl3 () {
        return imgSrc('fc01.xlsx')
      },
      containerId () {
        return this.$route.query.ID
      },
      uploadUrl () {
        return uploadImg()
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
</style>
